(function () {
  function initializeCartShipping() {
  const roots = [...document.querySelectorAll('[data-cart-shipping]')];
  if (!roots.length) return;
  const base = window.Shopify?.routes?.root || '/';
  const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
  const dates = new Intl.DateTimeFormat('es-MX', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  const provinces = {AGU:'Aguascalientes',BCN:'Baja California',BCS:'Baja California Sur',CAM:'Campeche',CHP:'Chiapas',CHH:'Chihuahua',CMX:'Ciudad de México',COA:'Coahuila',COL:'Colima',DUR:'Durango',GUA:'Guanajuato',GRO:'Guerrero',HID:'Hidalgo',JAL:'Jalisco',MEX:'México',MIC:'Michoacán',MOR:'Morelos',NAY:'Nayarit',NLE:'Nuevo León',OAX:'Oaxaca',PUE:'Puebla',QUE:'Querétaro',ROO:'Quintana Roo',SLP:'San Luis Potosí',SIN:'Sinaloa',SON:'Sonora',TAB:'Tabasco',TAM:'Tamaulipas',TLA:'Tlaxcala',VER:'Veracruz',YUC:'Yucatán',ZAC:'Zacatecas'};
  let active = null;
  let generation = 0;
  let displayedSignature = '';
  let lastAutoKey = '';
  function savedPostal() {try {return JSON.parse(localStorage.getItem('clikea.shipping.destination.v1') || 'null')?.postalCode || '';} catch {return '';}}
  function autoQuote() {
    if (document.hidden) return;
    const root = roots.find(r => r.getClientRects().length && cartSnapshot(r)?.items.length);
    const postal = savedPostal();
    if (!root || !/^\d{5}$/.test(postal)) return;
    const key = postal + ':' + root.dataset.cartSignature;
    if (lastAutoKey === key) return;
    lastAutoKey = key;
    root.querySelector('[data-cart-shipping-postal]').value = postal;
    root.querySelector('[data-cart-shipping-inline-postal]').value = postal;
    void quote(root);
  }
  const cache = new Map();
  function cartSnapshot(root) {
    try {
      const [items,total] = JSON.parse(root.dataset.cartSignature || 'null');
      if (!Array.isArray(items) || !Number.isInteger(total) || total < 0 || !items.every(i => Array.isArray(i) && typeof i[0] === 'string' && Number.isInteger(i[1]) && i[1] > 0)) return null;
      return {items:items.map(i=>({key:i[0],quantity:i[1]})),total_price:total};
    } catch { return null; }
  }
  function restoreQuote(root,postalCode) {
    const cart = cartSnapshot(root);
    if (!cart?.items.length || !/^\d{5}$/.test(postalCode)) return false;
    try {
      const now = clock(),key = `${now.date}:${now.hour < 15}:${postalCode}:${signature(cart)}`;
      const cached = cache.get(key) || JSON.parse(sessionStorage.getItem('clikea.cart.shipping.v1') || 'null');
      if (cached?.key !== key || !Number.isFinite(cached.expires) || cached.expires <= Date.now() || signature(cached.cart) !== signature(cart) || cached.quote?.postalCode !== postalCode || typeof cached.quote.destination !== 'string' || !Array.isArray(cached.quote.rates) || !cached.quote.rates.length || !cached.quote.rates.every(r=>typeof r.service==='string' && Number.isFinite(r.amount) && r.amount>=0)) return false;
      render(cached.quote,cart);return true;
    } catch { return false; }
  }
  function readAddress(postalCode) {
    try {
      const value = JSON.parse(sessionStorage.getItem('clikea.cart.shipping.address.v1') || 'null');
      return value?.postalCode === postalCode && value.expires > Date.now() && Object.values(provinces).includes(value.province) && typeof value.city === 'string' && value.city.length > 0 && value.city.length <= 150 ? value : null;
    } catch { return null; }
  }

  const preferenceKey = 'clikea.cart.shipping.preference.v1';
  const transferKey = 'clikea.product.shipping.service.v1';
  function make(tag, cls, text) { const e = document.createElement(tag); e.className = cls; if (text != null) e.textContent = text; return e; }
  function pause(ms, signal) {
    return new Promise((resolve,reject) => {
      if (signal.aborted) { reject(new DOMException('Aborted','AbortError')); return; }
      const cancel = () => { clearTimeout(timer); reject(new DOMException('Aborted','AbortError')); };
      const timer = setTimeout(() => { signal.removeEventListener('abort',cancel); resolve(); },ms);
      signal.addEventListener('abort',cancel,{once:true});
    });
  }
  function clock() {
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/Mexico_City',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
    const get = t => parts.find(p => p.type === t)?.value;
    return {date:`${get('year')}-${get('month')}-${get('day')}`,hour:Number(get('hour'))};
  }
  function signature(cart) { return JSON.stringify([cart.items.map(i => [i.key, i.quantity]), cart.total_price]); }
  function dateLabel(value) { return /^\d{4}-\d{2}-\d{2}$/.test(value || '') ? dates.format(new Date(value + 'T12:00:00Z')) : ''; }
  function nextBusiness(date) { do { date.setUTCDate(date.getUTCDate() + 1); } while ([0,6].includes(date.getUTCDay())); return date; }
  function delivery(rate) {
    const now = clock(); let d = new Date(now.date + 'T12:00:00Z');
    if ([0,6].includes(d.getUTCDay()) || now.hour >= 15) d = nextBusiness(d);
    const days = Array.isArray(rate.delivery_days) ? rate.delivery_days.filter(n => Number.isInteger(n) && n >= 0 && n <= 30) : [];
    if (days.length) for (let i = 0; i < Math.max(...days); i++) d = nextBusiness(d);
    const operational = days.length ? d.toISOString().slice(0,10) : '';
    const provider = /^\d{4}-\d{2}-\d{2}$/.test(rate.delivery_date || '') ? rate.delivery_date : '';
    return [operational,provider].filter(Boolean).sort().at(-1) || '';
  }
  function busy(value) { roots.forEach(r => { r.querySelector('[data-cart-shipping-calculate]').disabled = value; r.dataset.cartShippingPending = String(value); r.querySelector('[data-cart-shipping-rates]').setAttribute('aria-busy', String(value)); }); }
  function status(text, quiet = false) { roots.forEach(r => {r.querySelector('[data-cart-shipping-status]').textContent = text;const inline=r.querySelector('[data-cart-shipping-inline-status]');inline.textContent=text;inline.hidden=quiet || !text;}); }
  function pendingQuote(postalCode, pending = true) {
    displayedSignature = '';
    window.clikeaCartShipping = null;
    window.clikeaCartShippingPostal = postalCode;
    window.dispatchEvent(new CustomEvent('clikea:cart-shipping-reset', {detail:{pending,postalCode}}));
    roots.forEach(root => {
      const destination = root.dataset.cartShippingPostal === postalCode ? root.querySelector('[data-cart-delivery-destination]').textContent : '';
      root.querySelector('[data-cart-shipping-rates]').hidden = true;
      root.querySelector('[data-cart-shipping-benefit]').hidden = true;
      root.querySelector('[data-cart-shipping-preference]').hidden = true;
      root.querySelector('[data-cart-shipping-fallback]').hidden = true;
      root.querySelector('[data-cart-shipping-inline]').hidden = /^\d{5}$/.test(postalCode);
      root.querySelector('[data-cart-delivery-title]').textContent = '';
      root.querySelector('[data-cart-delivery-destination]').textContent = destination;
      root.querySelector('[data-cart-delivery-date]').textContent = 'Entrega por confirmar';
      root.dataset.cartShippingPostal = postalCode;
    });
    status('El costo y la fecha se confirman con tu dirección al pagar.', true);
  }

  function selectRate(quote, cart, rate, remember) {
    const currentRoot = roots.find(root => root.getClientRects().length) || roots[0];
    const currentCart = cartSnapshot(currentRoot);
    if (!currentCart || signature(cart) !== signature(currentCart) || quote.postalCode !== currentRoot.dataset.cartShippingPostal) return;
    const key = `${quote.postalCode}:${signature(cart)}`;
    window.clikeaCartShipping = {amount:Math.round(rate.amount*100),service:rate.service,hasFreeOption:quote.rates.some(option => option.amount === 0)};
    window.dispatchEvent(new CustomEvent('clikea:cart-shipping-selected',{detail:window.clikeaCartShipping}));
    if (remember) {
      try { sessionStorage.setItem(preferenceKey,JSON.stringify({key,service:rate.service,amount:rate.amount})); } catch {}
      try {sessionStorage.removeItem(transferKey);} catch {}
    }
    roots.forEach(root => {
      root.querySelector('[data-cart-delivery-title]').textContent = '';
      root.querySelector('[data-cart-delivery-destination]').textContent = quote.destination;
      root.querySelector('[data-cart-delivery-date]').textContent = dateLabel(rate.date) ? 'Llega el ' + dateLabel(rate.date) : 'Fecha por confirmar al pagar';
      root.querySelectorAll('[data-cart-shipping-rate]').forEach(input => {
        input.checked = input.dataset.cartShippingRate === `${rate.service}|${rate.amount}`;
      });
      const benefit = root.querySelector('[data-cart-shipping-benefit]');
      const missing = Math.max(0,119900 - cart.total_price);
      benefit.textContent = rate.amount === 0 ? 'Esta opción tiene envío de $0. Confírmala al pagar.' : quote.rates.some(r => r.amount === 0) ? 'También tienes una opción de envío gratis.' : missing > 0 ? `Agrega ${money.format(missing/100)} para alcanzar la promoción de envío desde $1,199 MXN, según cobertura.` : 'La tarifa incluye el excedente de esta opción según cobertura.';
      benefit.hidden = rate.amount === 0;
      const note = root.querySelector('[data-cart-shipping-preference]');
      note.textContent = `Preferencia: ${rate.service}. Confirma este servicio al pagar.`;
      note.hidden = false;
    });
  }
  function render(quote, cart) {
    displayedSignature = signature(cart);
    const key = `${quote.postalCode}:${signature(cart)}`;
    let remembered;
    try { remembered = JSON.parse(sessionStorage.getItem(preferenceKey) || 'null'); } catch {}
    const chosen = remembered?.key === key ? quote.rates.find(r => r.service === remembered.service && r.amount === remembered.amount) : null;
    let productPreference;
    try {productPreference = JSON.parse(sessionStorage.getItem(transferKey) || 'null');} catch {}
    const applicable = productPreference?.expiresAt > Date.now() && productPreference.postalCode === quote.postalCode && cart.items.some(i => Number(i.variant_id || String(i.key).split(':')[0]) === productPreference.variantId);
    const fromProduct = applicable ? quote.rates.find(r => r.service === productPreference.service) : null;
    const selected = fromProduct || chosen || quote.rates.find(r => r.amount === 0) || quote.rates[0];
    roots.forEach(root => {
      root.querySelector('[data-cart-shipping-fallback]').hidden = true;
      root.querySelector('[data-cart-shipping-inline]').hidden = true;
      root.querySelector('[data-cart-shipping-postal]').value = quote.postalCode;
      root.dataset.cartShippingPostal = quote.postalCode;
      const list = root.querySelector('[data-cart-shipping-rates]'); list.replaceChildren();
      quote.rates.forEach(rate => {
        const row = make('label','clc-shipping__rate');
        const choice = make('input','clc-shipping__choice');
        choice.type = 'radio';
        choice.name = 'clc-shipping-rate-' + (root.dataset.cartShippingContext || 'cart');
        choice.value = rate.service;
        choice.dataset.cartShippingRate = `${rate.service}|${rate.amount}`;
        choice.addEventListener('change',() => {
          if (choice.checked && (window.clikeaCartShipping?.service !== rate.service || window.clikeaCartShipping?.amount !== Math.round(rate.amount*100))) selectRate(quote,cart,rate,true);
        });
        choice.addEventListener('keydown',event => {if (event.key === 'Enter') {event.preventDefault();choice.click();}});
        row.addEventListener('click',event => {
          if (event.target !== choice) event.preventDefault();
          selectRate(quote,cart,rate,true);
          root.querySelector('[data-cart-shipping-dialog]').close();
        });
        row.append(choice,make('strong','',rate.service));
        const cost = make('div','clc-shipping__price');
        if (rate.amount === 0 && /estafeta/i.test(rate.service)) {
          const reference = make('span','clc-shipping__reference','Referencia '); reference.append(make('s','',money.format(139))); cost.append(reference);
        }
        cost.append(make('b','',rate.amount === 0 ? 'Gratis' : money.format(rate.amount))); row.append(cost);
        row.append(make('small','',dateLabel(rate.date) ? `Entrega estimada: ${dateLabel(rate.date)}` : 'Fecha por confirmar al pagar')); list.append(row);
      });
      list.hidden = false;
      root.querySelector('[data-cart-shipping-status]').textContent = quote.destination;root.querySelector('[data-cart-shipping-inline-status]').hidden=true;
    });
    selectRate(quote,cart,selected,false);
    try { localStorage.setItem('clikea.shipping.destination.v1', JSON.stringify({postalCode:quote.postalCode,destination:quote.destination})); } catch {}
    window.dispatchEvent(new CustomEvent('clikea:shipping-quoted', {detail:quote}));
  }
  async function quote(root) {
    const postalCode = root.querySelector('[data-cart-shipping-postal]').value.trim();
    if (!/^\d{5}$/.test(postalCode)) {
      active?.abort(); generation++; active=null;
      window.clikeaCartShipping = null; window.dispatchEvent(new Event('clikea:cart-shipping-reset'));
      roots.forEach(r => {r.querySelector('[data-cart-shipping-rates]').hidden=true;r.querySelector('[data-cart-shipping-benefit]').hidden=true;r.querySelector('[data-cart-shipping-preference]').hidden=true;r.querySelector('[data-cart-shipping-fallback]').hidden=false;r.querySelector('[data-cart-delivery-destination]').textContent='';r.querySelector('[data-cart-delivery-date]').textContent='';r.querySelector('[data-cart-delivery-title]').textContent='Envío por confirmar al pagar';});
      busy(false); status('Ingresa un código postal de cinco dígitos.'); return;
    }
    if (restoreQuote(root,postalCode)) {
      active?.abort();generation++;active=null;busy(false);status('');return;
    }
    active?.abort(); const controller = new AbortController(); active = controller; const current = ++generation; let timeout;
    pendingQuote(postalCode);
    busy(true);
    const requestDeadline = Date.now() + 14000;
    const request = async (url, method = 'GET') => {
      for (let attempt = 0; attempt < 2; attempt++) {
        let response;
        try { response = await fetch(url, {method,credentials:url.startsWith(base)?'same-origin':'omit',signal:controller.signal,headers:{accept:'application/json'}}); }
        catch (error) {
          if (attempt || controller.signal.aborted || Date.now() > requestDeadline - 2000) throw error;
          await pause(400,controller.signal); continue;
        }
        if (response.ok) return response;
        if (!attempt && response.status >= 500 && Date.now() < requestDeadline - 2000) { await pause(400,controller.signal); continue; }
        const error = new Error(url.includes('geocodes.envia.com') && response.status === 404 ? 'Revisa tu código postal. El cotizador rápido no pudo validarlo.' : 'No pudimos consultar las opciones de envío en este momento.');
        error.status = response.status;
        throw error;
      }
    };
    try {
      timeout = setTimeout(() => controller.abort(), 14000);
      const cart = cartSnapshot(root) || await (await request(base + 'cart.js')).json();
      if (!cart.items.length) throw new Error('Añade productos a tu carrito para calcular el envío.');
      if (current !== generation) return;
      displayedSignature = signature(cart);
      const now = clock(); const key = `${now.date}:${now.hour < 15}:${postalCode}:${signature(cart)}`;
      let cached;
      let place = readAddress(postalCode);
      if (!place) {
        const data = await (await request('https://geocodes.envia.com/zipcode/MX/' + postalCode)).json();
        const location = Array.isArray(data) ? data.find(x => x.zip_code === postalCode) : data;
        const province = provinces[location?.state?.iso_code?.replace('MX-','')];
        const city = location?.locality || location?.regions?.region_2;
        if (!province || !city) throw new Error('No pudimos validar ese código postal.');
        place = {postalCode,province,city,expires:Date.now()+300000};
        try {sessionStorage.setItem('clikea.cart.shipping.address.v1',JSON.stringify(place));} catch {}
      }
      const {province,city} = place;
      const address = new URLSearchParams({'shipping_address[zip]':postalCode,'shipping_address[country]':'Mexico','shipping_address[province]':province,'shipping_address[city]':city});
      await request(base + 'cart/prepare_shipping_rates.json?' + address,'POST');
      let rates = null; const deadline = Date.now() + 8000;
      for (const delay of [0,150,300,500,800,1200,1800,2300]) {
        if (delay) await pause(delay,controller.signal);
        if (Date.now() >= deadline || controller.signal.aborted) break;
        const value = await (await request(base + 'cart/async_shipping_rates.json?' + address)).json();
        if (Array.isArray(value?.shipping_rates)) {rates = value.shipping_rates;break;}
      }
      if (!rates) throw new Error('Las tarifas siguen calculándose. Vuelve a intentarlo en unos segundos.');
      const options = rates.filter(r => /envia|skydropx/i.test(r.source || '') && !/fedex/i.test(r.name || '')).map(r => ({service:String(r.name || 'Entrega').slice(0,70),amount:Number(r.price),date:delivery(r)})).filter(r => Number.isFinite(r.amount) && r.amount >= 0).sort((a,b) => a.amount-b.amount);
      if (!options.length) throw new Error('No pudimos confirmar una tarifa. Revisa las opciones al pagar.');
      const freshCart = await (await request(base + 'cart.js')).json();
      if (signature(cart) !== signature(freshCart)) throw new Error('Tu carrito cambió. Vuelve a calcular el envío.');
      const result = {postalCode,destination:city.toLowerCase() === province.toLowerCase()?city:`${city}, ${province}`,rates:options};
      if (current !== generation) return;
      cached = {key,quote:result,cart:{items:cart.items.map(i=>({key:i.key,quantity:i.quantity})),total_price:cart.total_price},expires:Date.now()+300000};cache.set(key,cached);
      if (cache.size > 10) cache.delete(cache.keys().next().value);
      try {sessionStorage.setItem('clikea.cart.shipping.v1',JSON.stringify(cached));} catch {}
      render(result,cart);
    } catch (error) {
      if (current === generation) {
        window.dispatchEvent(new CustomEvent('clikea:cart-shipping-reset',{detail:{pending:false,postalCode}}));
        roots.forEach(r=>{r.querySelector('[data-cart-shipping-inline]').hidden=false;});
        status(error.name === 'AbortError' ? 'La consulta rápida no terminó a tiempo.' : error.message);
        roots.forEach(r => {r.querySelector('[data-cart-shipping-fallback]').hidden=false;r.querySelector('[data-cart-delivery-title]').textContent='Envío por confirmar al pagar';r.querySelector('[data-cart-delivery-destination]').textContent='';r.querySelector('[data-cart-delivery-date]').textContent='';});
      }
    } finally {clearTimeout(timeout);if (current === generation) {active=null;busy(false);} }
  }
  roots.forEach(root => {
    function restore() { restoreQuote(root,savedPostal()); }
    const dialog = root.querySelector('[data-cart-shipping-dialog]');
    root.querySelector('[data-cart-shipping-open]').addEventListener('click',() => dialog.showModal());
    root.querySelector('[data-cart-shipping-open]').disabled = false;
    root.dataset.cartShippingReady = 'true';
    root.querySelector('[data-cart-shipping-close]').addEventListener('click',() => dialog.close());
    dialog.addEventListener('keydown',event => {if (event.key === 'Escape') {event.preventDefault();event.stopPropagation();dialog.close();}});
    dialog.addEventListener('click',event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
    dialog.addEventListener('close',() => {if (active) active.abort();});
    try {root.querySelector('[data-cart-shipping-postal]').value = JSON.parse(localStorage.getItem('clikea.shipping.destination.v1') || 'null')?.postalCode || '';} catch {}
    root.querySelector('[data-cart-shipping-calculate]').addEventListener('click',() => quote(root));
    root.querySelector('[data-cart-shipping-postal]').addEventListener('keydown',event => {if (event.key === 'Enter') {event.preventDefault();quote(root);} });
    new MutationObserver(() => {
      if (active && !displayedSignature) return;
      if (root.dataset.cartSignature === displayedSignature) return;
      const postalCode = savedPostal();
      // A matching quote is restored before clearing totals or delivery details.
      if (restoreQuote(root, postalCode)) {
        active?.abort(); generation++; active = null; busy(false); status(''); return;
      }
      active?.abort(); generation++; active = null; displayedSignature = ''; busy(false);
      lastAutoKey = '';
      if (document.hidden || !/^\d{5}$/.test(postalCode) || !cartSnapshot(root)?.items.length) {
        pendingQuote(postalCode, false); return;
      }
      autoQuote();
    }).observe(root,{attributes:true,attributeFilter:['data-cart-signature']});

    const inline = root.querySelector('[data-cart-shipping-inline-postal]');
    inline.value = savedPostal();
    const calculateInline = () => {root.querySelector('[data-cart-shipping-postal]').value=inline.value;void quote(root);};
    root.querySelector('[data-cart-shipping-inline-calculate]').addEventListener('click',calculateInline);
    inline.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();calculateInline();}});
    restore();
    window.addEventListener('clikea:shipping-service-preferred',restore);
  });
  autoQuote();
  window.addEventListener('clikea:shipping-destination-saved',autoQuote);
  window.addEventListener('clikea:shipping-cleared',()=>{
    active?.abort();generation++;active=null;lastAutoKey='';displayedSignature='';busy(false);window.clikeaCartShippingPostal='';
    window.clikeaCartShipping=null;window.dispatchEvent(new CustomEvent('clikea:cart-shipping-reset'));
    roots.forEach(r=>{r.querySelector('[data-cart-shipping-postal]').value='';r.querySelector('[data-cart-shipping-inline-postal]').value='';r.querySelector('[data-cart-shipping-inline]').hidden=false;r.querySelector('[data-cart-delivery-title]').textContent='Consulta costo y entrega';r.querySelector('[data-cart-delivery-destination]').textContent='';r.querySelector('[data-cart-delivery-date]').textContent='';r.querySelector('[data-cart-shipping-benefit]').hidden=true;r.querySelector('[data-cart-shipping-preference]').hidden=true;r.querySelector('[data-cart-shipping-rates]').replaceChildren();r.querySelector('[data-cart-shipping-rates]').hidden=true;r.querySelector('[data-cart-shipping-fallback]').hidden=true;});status('');cache.clear();try{sessionStorage.removeItem('clikea.cart.shipping.v1');sessionStorage.removeItem(preferenceKey);sessionStorage.removeItem(transferKey);}catch{}
  });
  document.addEventListener('visibilitychange',() => {if (document.hidden) {active?.abort();lastAutoKey='';} else autoQuote(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeCartShipping,{once:true});
  else initializeCartShipping();
})();
